export const formatTime = (time: number) => {
    const date = new Date(time * 1000);
    const norwayTime = date.toLocaleTimeString('en-GB', {
        timeZone: 'Europe/Oslo',
        hour: '2-digit',
        minute:'2-digit'
    });
    return norwayTime;
};
